/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelPayrollControlMulticurrency.ts   *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/payroll-control-multicurrency";

export class AutogenModelPayrollControlMulticurrency<RowType extends ModelRow> extends Endpoint<RowType, RowPayrollControlMulticurrencyFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowPayrollControlMulticurrency extends ModelRow<RowPayrollControlMulticurrencyFields> {
	constructor(values?: Partial<RowPayrollControlMulticurrencyFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowPayrollControlMulticurrencyFields {
	ach_batch_class_code: string;
	ach_optional_security_ln: string;
	agent_cash_glid: string;
	bank_number: string;
	carrier_cash_glid: string;
	carrier_interface_cash_glid: string;
	co_discr_data: string;
	company_id: string;
	contract_cash_glid: string;
	cpa_code: number;
	currency_type: string;
	dir_dep_class_desc: string;
	dir_dep_comp_id: string;
	dir_dep_days: number;
	dir_dep_dest_flag: string;
	dir_dep_dest_name: string;
	dir_dep_filename: string;
	dir_dep_format: string;
	dir_dep_holiday: string;
	dir_dep_min_amt: number;
	dir_dep_min_amt_c: string;
	dir_dep_min_amt_d: Date;
	dir_dep_min_amt_n: number;
	dir_dep_min_amt_r: number;
	dir_dep_orig_name: string;
	dir_dep_orig_num: string;
	dir_dep_printdebit: string;
	dir_dep_saturday: string;
	dir_dep_sepfile_co: string;
	dir_dep_sunday: string;
	driver_cash_glid: string;
	eft_file_number: number;
	fed_reserve_num: string;
	fuel_cash_glid: string;
	id: string;
	leaseop_cash_glid: string;
	office_cash_glid: string;
	originator_id: string;
	print_zero_debit: string;
}

